import React, { useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Alert
} from 'reactstrap';
import { Package } from 'lucide-react';

const StockDetailsModal = ({ 
  isOpen, 
  toggle, 
  productName, 
  stockDetails = []
}) => {
  // Debug logging
  console.log('StockDetailsModal - isOpen:', isOpen);
  console.log('StockDetailsModal - stockDetails:', stockDetails);
  console.log('StockDetailsModal - productName:', productName);
  
  // Track modal state changes and logs
  useEffect(() => {
    if (isOpen) {
      console.log('StockDetailsModal opened for product:', productName);
    } else {
      console.log('StockDetailsModal closed');
    }
  }, [isOpen, productName]);
  
  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      return new Date(dateStr).toLocaleDateString('en-GB');
    } catch {
      return dateStr;
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      size="lg" 
      className="stock-details-modal"
      wrapClassName="stock-details-modal__wrapper"
      modalClassName="stock-details-modal__dialog"
      backdropClassName="stock-details-modal__backdrop"
      zIndex={2001}
      container={typeof document !== 'undefined' ? document.body : undefined}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>
        <Package className="me-2" size={20} />
        Stock Details - {productName}
      </ModalHeader>
      <ModalBody>
        {stockDetails.length === 0 ? (
          <Alert color="info" className="text-center">
            No stock data available for this product.
          </Alert>
        ) : (
          <Table responsive striped>
            <thead>
              <tr>
                <th>Serial No</th>
                <th>Batch Number</th>
                <th>Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              {stockDetails.map((stock, index) => (
                <tr key={stock.stockTransaction_StockId || stock.StockTransaction_StockId}>
                  <td>{index + 1}</td>
                  <td>{stock.purchaseStock_BatchNo || stock.PurchaseStock_BatchNo || 'N/A'}</td>
                  <td>{formatDate(stock.purchaseStock_ExpDate || stock.PurchaseStock_ExpDate)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StockDetailsModal;
